export const invoiceTypeColorMap = new Map([
  [1, '#ff4d4f'],
  [0, '#1890ff'],
])
export const invoiceTypeTextMap = new Map([
  [1, '专票'],
  [0, '普票'],
])
export const invoiceNewTypeTextMap = new Map([
  [1, '专用发票'],
  [0, '普通发票'],
])
export const invoiceListStorageKey = 'userInvoiceStorageKey'
export const addressListStorageKey = 'useraddressStorageKey'
export const invoiceEditItemStorageKey = 'invoiceEditItemStorageKey'
export const addressEditItemStorageKey = 'addressEditItemStorageKey'
export const confirmUseInvoiceStorageKey = 'confirmUseInvoiceStorageKey'
export const selectInoviceStorageKey = 'selectInoviceStorageKey'
export const selectAddressStorageKey = 'selectAddressStorageKey'
export const cacheFromStorageKey = 'cacheFromStorageKey'
export const templateImageUrl =
  'https://static.knowledge.xag.cn/doc/device-replace/individual-payment-certificate.png' // 代付款证明模板
